import { getField, updateField } from "vuex-map-fields";
import db from "@/firebase/firebaseInit";

const state = {
    latestUsers: [],
    totalUsers: []
};

const actions = {
    async fetchLatestUsers({ commit }) {
        //TODO:: Change the Volunteers end point to Users end point
        
        // order by name

        await db.collection('/volunteers').get().then(
            (snapshot) => {
                var latestUsers = [];
                snapshot.forEach(doc => {
                    latestUsers.push(doc.data());
                });
                commit("updateField", {
                    path: "latestUsers",
                    value: latestUsers,
                })
            });
    },
    async fetchTotalUsers({ commit }) {
        //TODO:: Change the Volunteers end point to Users end point
        // put a higher limit for total users 
        // and fetch more as required 
        await db.collection('/volunteers').get().then(
            (snapshot) => {
                var totalUsers = [];
                snapshot.forEach(doc => {
                    totalUsers.push(doc.data());
                });
                commit("updateField", {
                    path: "totalUsers",
                    value: totalUsers,
                })
            });
    },
    async fetchLatestUsers2({ commit }) {
        //TODO:: Change the Volunteers end point to Users end point
        
        // order by name

        await db.collection('/pandemic2volunteers').get().then(
            (snapshot) => {
                var latestUsers = [];
                snapshot.forEach(doc => {
                    latestUsers.push(doc.data());
                });
                commit("updateField", {
                    path: "latestUsers",
                    value: latestUsers,
                })
            });
    },
    async fetchTotalUsers2({ commit }) {
        //TODO:: Change the Volunteers end point to Users end point
        // put a higher limit for total users 
        // and fetch more as required 
        await db.collection('/pandemic2volunteers').get().then(
            (snapshot) => {
                var totalUsers = [];
                snapshot.forEach(doc => {
                    totalUsers.push(doc.data());
                });
                commit("updateField", {
                    path: "totalUsers",
                    value: totalUsers,
                })
            });
    }
};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
